import { render, staticRenderFns } from "./BannerBlog.vue?vue&type=template&id=de993c80&"
var script = {}
import style0 from "./BannerBlog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports